import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import AuthService from "../../services/auth.service";

export const fetchStatements= createAsyncThunk('fetchStatements', async (data:any) => {   
    const response = await AuthService.statements(data);
    return response?.data;   
});


export const txnSlice = createSlice({
    name: 'txns',
    initialState: {
        isLoading: false,
        statementsData: [] as any,
        current_page: 1, 
        filterData:{
            type:'',
            from:'',
            to:''            
        },
        page:1, 
        next_page_url:'',
        call_by:'page',
        //isError: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchStatements.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStatements.fulfilled, (state, action) => {  
            //console.log(action)                     
            state.filterData = action?.meta?.arg;            
            state.page= action.payload?.current_page;
            state.isLoading = false;
            state.next_page_url = action.payload?.next_page_url;
            state.call_by = action?.meta?.arg?.callBy;
            //if(action.payload?.current_page===1){
                state.statementsData = action.payload?.data;
            //}else{
                //state.statementsData = [...state.statementsData, ...action.payload?.data];
           // }
            
           
        });
        // builder.addCase(fetchStatements.rejected, (state, action) => {
        //     console.log('Error', action.payload);
        //     state.isError = true;
        // });
    }
})

export default txnSlice.reducer